import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PremiumFeatures.css';

const PremiumFeatures = () => {
  const navigate = useNavigate();
  return (
    <section className="premium-features">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">All-in-One Growth Solution for Healthcare Professionals</h2>
          <p className="section-description">
            Boost your practice with AI Marketing to reach the right patients, a Professional Website to showcase your expertise, 
            and powerful Management Software to keep everything running smoothly. Get real, measurable results that grow your 
            reputation and revenue.
          </p>
        </div>

        <div className="features-grid">
          {/* AI Marketing Feature */}
          <div className="feature-card ai-marketing">
            <div className="feature-icon12">
              <div className="icon-wrapper">
                <i className="fas fa-robot"></i>
              </div>
            </div>
            <div className="feature-content">
              <h3 className="feature-title">AI Marketing</h3>
              <p className="feature-description">
                Leverage advanced AI tools to target the right audience, increase patient engagement, 
                and maximize your marketing ROI.
              </p>
              <ul className="feature-benefits">
                <li><i className="fas fa-check"></i> Smart audience targeting</li>
                <li><i className="fas fa-check"></i> Automated campaign optimization</li>
                <li><i className="fas fa-check"></i> Data-driven insights</li>
              </ul>
            </div>
          </div>

          {/* Professional Website Feature */}
          <div className="feature-card professional-website">
            <div className="feature-icon12">
              <div className="icon-wrapper">
                <i className="fas fa-globe"></i>
              </div>
            </div>
            <div className="feature-content">
              <h3 className="feature-title">Professional Website</h3>
              <p className="feature-description">
                Get a sleek, mobile-friendly website designed to reflect your expertise and build 
                trust with potential patients.
              </p>
              <ul className="feature-benefits">
                <li><i className="fas fa-check"></i> Mobile-responsive design</li>
                <li><i className="fas fa-check"></i> SEO optimized content</li>
                <li><i className="fas fa-check"></i> Professional branding</li>
              </ul>
            </div>
          </div>

          {/* Management Software Feature */}
          <div className="feature-card management-software">
            <div className="feature-icon12">
              <div className="icon-wrapper">
                <i className="fas fa-cogs"></i>
              </div>
            </div>
            <div className="feature-content">
              <h3 className="feature-title">Management Software</h3>
              <p className="feature-description">
                Streamline appointment scheduling, patient records, billing, and other administrative 
                tasks — all in one easy-to-use system.
              </p>
              <ul className="feature-benefits">
                <li><i className="fas fa-check"></i> Appointment scheduling</li>
                <li><i className="fas fa-check"></i> Patient records management</li>
                <li><i className="fas fa-check"></i> Integrated billing system</li>
              </ul>
            </div>
          </div>

          
        </div>

        <div className="cta-section">
          <div className="cta-content">
            <h3 style={{position: 'relative', color: '#fff'}}>Ready to Transform Your Practice?</h3>
            <p style={{color: '#fff'}}>Join thousands of healthcare professionals who have already grown their practice with our comprehensive solution.</p>
            <button className="btn btn-primary" onClick={() => navigate('/packages')} style={{position: 'relative', zIndex: '1'}}>
              <span>Get Started Today </span>
              <i className="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PremiumFeatures;
